
import { ResponseErrorHandling } from "../../../../helper";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getExchangeRate = (data) => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.post(`/client/coingecko/exchange-rate`, data);
    const exchangeRate = res.data;

    return exchangeRate;
  } catch (err) {
    const message = err.response?.data?.message || err.message || err.toString();
    
    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    
    throw err;
  } finally {
    // Reset pending spinner animations
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
